export default __webpack_public_path__ + "static/media/star4.c39dd543.gif";